import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ADVERTISEMENTS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getAdvertisementsAction = createAsyncThunk(
    'pod/getAdvertisementsAction',
    async (podId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ ADVERTISEMENTS_PATH }${ buildQueryString(podId) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAdvertisementsSlice = createSlice({
    name: 'getAdvertisementsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAdvertisementsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAdvertisementsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAdvertisementsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getAdvertisementsState = (state) => state.pod.getAdvertisements;
export default getAdvertisementsSlice.reducer;